import React, { useCallback, useEffect, useState } from 'react';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import qlog from 'views_shared/app/javascript/scripts/qlog';

// Valid Bootstrap background variants
const VALID_VARIANTS = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'];

// Helper function to truncate strings and log warnings if needed
function truncateWithWarning(str, maxLength, fieldName) {
  if (!str) return str;
  if (str.length <= maxLength) return str;

  qlog.warn(`Toast ${fieldName} exceeded maximum length (${maxLength}) and was truncated:`, str);
  return `${str.substring(0, maxLength)}...`;
}

function Toasts() {
  const [toasts, setToasts] = useState([]);
  const toastsVisibleSecs = 5;

  const showToast = useCallback(
    (toast) => {
      // Validate variant if provided
      if (toast.variant && !VALID_VARIANTS.includes(toast.variant)) {
        qlog.error(`Invalid toast variant: "${toast.variant}". Valid variants are: ${VALID_VARIANTS.join(', ')}`);
      }

      // Truncate fields if they're too long
      const processedToast = {
        ...toast,
        toastTitle: truncateWithWarning(toast.toastTitle, 30, 'title'),
        toastBody: truncateWithWarning(toast.toastBody, 250, 'body'),
        toastLink: truncateWithWarning(toast.toastLink, 500, 'link'),
        id: Math.random(),
        show: true,
      };

      setToasts((currentToasts) => [...currentToasts, processedToast]);
    },
    [setToasts],
  );

  useEffect(() => {
    globalThis.Qwoted.showToast = showToast;
  }, [showToast]);

  const handleClose = useCallback((id) => {
    setToasts((currentToasts) => currentToasts.map((toast) => (toast.id === id ? { ...toast, show: false } : toast)));
  }, []);

  return (
    <ToastContainer className="position-fixed top-0 end-0 p-3" position="top-end" style={{ zIndex: 1090 }}>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          onClose={() => handleClose(toast.id)}
          show={toast.show}
          delay={toastsVisibleSecs * 1000}
          autohide
          bg={toast.variant ? `${toast.variant}-subtle` : 'light'}
        >
          <Toast.Header>
            <strong className="me-auto">{toast.toastTitle}</strong>
          </Toast.Header>
          <Toast.Body>
            {toast.toastLink ? <a href={toast.toastLink}>{toast.toastBody}</a> : <span>{toast.toastBody}</span>}
          </Toast.Body>
        </Toast>
      ))}
    </ToastContainer>
  );
}

export default Toasts;
